export const defaultShapeProps: Omit<ShapeStruct, 'width' | 'height'> = {
  margin: 0,
  padding: 0,
};

export function normalizeSpacing(spacing: SpacingType): SpacingSidesStruct {
  if (spacing && typeof spacing === 'object') {
    if ('horizontal' in spacing || 'vertical' in spacing) {
      const { horizontal = 0, vertical = 0 } = spacing;

      return {
        left: horizontal,
        right: horizontal,
        top: vertical,
        bottom: vertical,
      };
    } else if (
      'left' in spacing ||
      'right' in spacing ||
      'top' in spacing ||
      'bottom' in spacing
    ) {
      const { left = 0, right = 0, top = 0, bottom = 0 } = spacing;
      return { left, right, top, bottom };
    }
  }

  if (typeof spacing !== 'number') {
    spacing = 0;
  }

  return {
    left: spacing,
    right: spacing,
    top: spacing,
    bottom: spacing,
  };
}

export function normalizeGap(
  gap?: SpacingAxisStruct | number
): SpacingAxisStruct {
  let gapSpacing: SpacingAxisStruct;
  if (typeof gap === 'number') {
    gapSpacing = { horizontal: gap, vertical: gap };
  } else if (gap) {
    gapSpacing = gap;
  } else {
    gapSpacing = { horizontal: 0, vertical: 0 };
  }

  return gapSpacing;
}

export function borderSide(
  border: BorderStruct
): keyof BorderSidesStruct | undefined {
  const sides: (keyof BorderSidesStruct)[] = ['left', 'right', 'top', 'bottom'];
  return sides.find(side => border[side] != null);
}

export function borderSideVertical(side: keyof BorderSidesStruct): boolean {
  return side === 'left' || side === 'right';
}

export function isFillStruct(
  fill?: FillStruct | CanvasFillStrokeStyles['fillStyle']
): fill is FillStruct {
  return typeof fill === 'object' && 'color' in fill;
}

export function isBorderStruct(
  border?: BorderStruct | CanvasFillStrokeStyles['strokeStyle']
): border is BorderStruct {
  if (typeof border !== 'object') return false;

  const sides: (keyof BorderSidesStruct)[] = ['left', 'right', 'top', 'bottom'];

  for (const side of sides) {
    if (border[side] !== undefined && typeof border[side] === 'string') {
      return true;
    }
  }

  if ('color' in border && typeof border.color === 'string') {
    return true;
  }

  return false;
}

export function getBorderColor(
  border?: BorderStruct | CanvasFillStrokeStyles['strokeStyle']
): CanvasFillStrokeStyles['strokeStyle'] | undefined {
  if (isBorderStruct(border)) {
    const side = borderSide(border);
    return side && border[side] ? border[side] : border.color;
  }

  return border;
}
